import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

const RellaxWrapper = forwardRef(({ 
  children, 
  className,
  style,
  ...props 
}, ref) => {
  // For now, just render a simple div wrapper
  // The parallax functionality can be added later if needed
  return (
    <div
      ref={ref}
      className={className}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
});

RellaxWrapper.displayName = 'RellaxWrapper';

RellaxWrapper.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
};

export default RellaxWrapper;
